import { writable } from 'svelte/store';
import type { toSessionUser } from '$lib/apis/adapters/session';

export type SessionUser = ReturnType<typeof toSessionUser>;
export const user = writable<SessionUser | null>(null);
